import React, { useState, useEffect } from 'react';
import styles from './DuplicateConnectionModal.module.css';
import SecureInput from '../../ui/SecureInput/SecureInput';
import { Environment } from '../../types/environment';

interface DuplicateConnectionModalProps {
  open: boolean;
  title?: string;
  initialName?: string;
  initialEnvironment?: Environment | '';
  confirmText?: string;
  cancelText?: string;
  onConfirm: (name: string, environment: Environment | '') => void;
  onCancel: () => void;
}

const DuplicateConnectionModal: React.FC<DuplicateConnectionModalProps> = ({
  open,
  title = 'Duplicate Connection',
  initialName = '',
  initialEnvironment = '',
  confirmText = 'Duplicate',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
}) => {
  const [name, setName] = useState(initialName);
  const [environment, setEnvironment] = useState<Environment | ''>(initialEnvironment);

  useEffect(() => {
    if (open) {
      setName(initialName);
      setEnvironment(initialEnvironment || '');
    }
  }, [initialName, initialEnvironment, open]);

  if (!open) return null;

  const handleConfirm = () => {
    if (name.trim()) {
      onConfirm(name.trim(), environment);
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        {title && <h3 className={styles.title}>{title}</h3>}
        <div className={styles.form}>
          <div className={styles.field}>
            <label className={styles.label}>Connection Name</label>
            <SecureInput
              fieldType="text"
              value={name}
              placeholder="Enter new connection name"
              onChange={(newValue) => setName(newValue)}
              className={styles.input}
              preserveWhitespace
            />
          </div>
          <div className={styles.field}>
            <label className={styles.label}>Environment</label>
            <select
              value={environment}
              onChange={(e) => setEnvironment(e.target.value as Environment | '')}
              className={styles.select}
            >
              <option value="">Not set</option>
              <option value="prod">Prod</option>
              <option value="test">Test</option>
              <option value="dev">Dev</option>
            </select>
          </div>
        </div>
        <div className={styles.actions}>
          <button className={styles.cancelBtn} onClick={onCancel}>{cancelText}</button>
          <button
            className={styles.confirmBtn}
            onClick={handleConfirm}
            disabled={!name.trim()}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DuplicateConnectionModal;
